import AssetManagerHub from '@/components/media/asset-manager-hub'
import { FeatureGate } from '@/components/feature-gate'

export default function MediaPage() {
  return (
    <FeatureGate feature="media">
      <div className="p-6 max-w-screen-xl mx-auto">
        <AssetManagerHub />
      </div>
    </FeatureGate>
  )
}
